module.exports = __webpack_public_path__ + "img/5.07167b3e.png";